export enum DisablerActionTypes {
  LOAD_DEVICES_STATUS_REQUEST = 'LOAD_DEVICES_STATUS_REQUEST',
  LOAD_DEVICES_STATUS_SUCCEEDED = 'LOAD_DEVICES_STATUS_SUCCEEDED',
  LOAD_DEVICES_STATUS_FAILED = 'LOAD_DEVICES_STATUS_FAILED',

  ASK_DISABLER_ACTION_REQUEST = 'ASK_DISABLER_ACTION_REQUEST',
  ASK_DISABLER_ACTION_SUCCEEDED = 'ASK_DISABLER_ACTION_SUCCEEDED',
  ASK_DISABLER_ACTION_FAILED = 'ASK_DISABLER_ACTION_FAILED',

  PUT_DISABLER_COMPLETED = 'PUT_DISABLER_COMPLETED',
}
